import React from 'react';
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import axios from "axios";
import toast from "react-hot-toast";

interface ContactFormData {
    name: string;
    email: string;
    message: string;
}

const useHandleContactForm = () => {
    const base_url = process.env.NEXT_PUBLIC_BASE_URL;
    const contactFormSchema = yup.object({
        name: yup.string().required("Name is required"),
        email: yup.string().email('Invalid email address').required("Email address is required"),
        message: yup.string().required("Message is required"),
    });
    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
        reset,
    } = useForm({
        resolver: yupResolver(contactFormSchema),
    });

    const handleContactForm = async (data: ContactFormData) => {
        try {
            const response = await axios.post(`${base_url}/api/blog/contact-forms`, {
                name: data.name,
                email: data.email,
                message: data.message,
            });
            toast.success('Your response has been submitted successfully!');
            console.log("Contact form response:", response?.data);
            reset();
        } catch (error: any) {
            toast.error(error?.response?.data?.message);
            console.error("Contact form error:", error);
        }
    };
  return {
    errors,
    isSubmitting,
    register,
    handleSubmit,
    handleContactForm,
  }
}

export default useHandleContactForm